import { Box, Typography } from "@mui/material";

/**
 * What a card shows when its query failed. Explicitly *not measured* — never a
 * zero, because on the hostile cards those are opposite claims and "nothing
 * attacked you" is the one a customer must not read out of a failure.
 *
 * A failed leg is never cached (security_overview_service), so reloading really
 * does retry rather than serving the same empty card for the TTL.
 */
export default function NotMeasured({ source }: { readonly source: string }) {
  return (
    <Box
      sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", px: 2, py: 3, minHeight: 120 }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", maxWidth: 320 }}>
        Not measured — {source} was unavailable when this page loaded, so no figure can be shown here. Reload to try
        again.
      </Typography>
    </Box>
  );
}
